import React, { useEffect, useRef, useState } from 'react';
import { Palette, Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import './ThemeSwitcher.css';

// 主题选项行（下拉与抽屉内共用）
const ThemeOption = ({ theme, active, onSelect }) => (
  <button
    type="button"
    className={`ts-option ${active ? 'active' : ''}`}
    onClick={() => onSelect(theme.id)}
  >
    <span className="ts-swatch">
      <span style={{ background: theme.swatch[0] }} />
      <span style={{ background: theme.swatch[1] }} />
    </span>
    <span className="ts-texts">
      <span className="ts-label">{theme.label}</span>
      <span className="ts-desc">{theme.desc}</span>
    </span>
    {active && <Check size={16} className="ts-check" />}
  </button>
);

// variant: 'icon' 导航栏图标下拉 / 'inline' 抽屉内平铺 / 'floating' 登录页悬浮
const ThemeSwitcher = ({ variant = 'icon' }) => {
  const { themeId, themes, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [open]);

  if (variant === 'inline') {
    return (
      <div className="ts-inline">
        {themes.map((t) => (
          <ThemeOption key={t.id} theme={t} active={t.id === themeId} onSelect={setTheme} />
        ))}
      </div>
    );
  }

  return (
    <div className={`ts-root ${variant === 'floating' ? 'ts-floating' : ''}`} ref={rootRef}>
      <button
        type="button"
        className="ts-trigger"
        aria-label="切换主题"
        title="切换主题"
        onClick={() => setOpen((v) => !v)}
      >
        <Palette size={18} />
      </button>
      {open && (
        <div className="ts-menu">
          {themes.map((t) => (
            <ThemeOption
              key={t.id}
              theme={t}
              active={t.id === themeId}
              onSelect={(id) => { setTheme(id); setOpen(false); }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeSwitcher;
